import { render, staticRenderFns } from "./huiwa.vue?vue&type=template&id=0925c2fa&scoped=true&"
import script from "./huiwa.vue?vue&type=script&lang=js&"
export * from "./huiwa.vue?vue&type=script&lang=js&"
import style0 from "./huiwa.vue?vue&type=style&index=0&id=0925c2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925c2fa",
  null
  
)

export default component.exports